<template>
  <div class="my-help">
    <div class="my-info-box">
      <div class="container">
        <div class="my-info-cont">
          <div class="user-photo">
            <img :src="userData.userPhoto" alt="">
          </div>
          <div class="user-name-box">
            <p class="user-name">{{userData.userName}}</p>
            <p class="user-introduce" :title="userData.userInfo">{{userData.userInfo}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="my-help-cont">
      <div class="container">
        <ul class="help-nav">
          <li :class="{active:helpNum === item.id}" @click="checkTab(item.id)" v-for="item in navList" :key="item.id">
            <span class="text">{{item.name}}</span>
            <span class="total">{{item.id === 1 ? questionTotal ? questionTotal : '' : answerTotal ? answerTotal : ''}}</span>
          </li>
        </ul>
        <div class="help-list-box">
          <div class="title">{{helpNum === 1? '我的提问' : '我的回答'}}</div>
          <myQuestion v-show="helpNum === 1" @getTotal="getTotal" ref="myQuestion"></myQuestion>
          <myAnswer :userData="userData" v-show="helpNum === 2" @getTotal="getTotal" ref="myAnswer"></myAnswer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios } from "@/../api/init";
import { zhugeTrack } from "@/../public/public";
import { isMobile } from "@/../public/public"
import myQuestion from "@/components/help/my-question"
import myAnswer from "@/components/help/my-answer"
export default {
  name: 'my-help',
  components:{
    myQuestion,
    myAnswer
  },
  data() {
    return {
      courseId:'', // 课程ID
      courseName:'', //课程名称
      helpNum: 1,
      sign:'',
      studentId:'',
      userData:{
        userPhoto:"",
        userName:"",
        userInfo:""
      },
      questionTotal: "",
      answerTotal:"",
      navList:[
        {id:1,name:'我的提问'},
        {id:2,name:'我的回答'}
      ]
    }
  },
  created(){
    if(isMobile()){
      window.location.href = '/qrcode.html#/'
    }
  },
  mounted(){
    this.courseId = this.$route.query.courseId
    this.IsAlive()
  },
  methods:{
    IsAlive() {
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/isAlive",
        method: "GET"
      }).then(res => {
        if (res.data.success) {
          let result = res.data.resultObject
          let sign =  this.getSign()//解析cookie中的sign
          localStorage.setItem('sign',sign)
          localStorage.setItem('studentId',res.data.resultObject.id)
          this.sign = localStorage.getItem('sign')
          this.studentId = localStorage.getItem('studentId')
          this.userData = {
            userPhoto: result.smallHeadPhoto,
            userName:result.name,
            userInfo:result.info
          }
          this.$nextTick(()=>{
            this.$refs.myQuestion.getMyQuestion()
            this.$refs.myAnswer.getMyAnswer()
            zhugeTrack('Web_进入我的问答页')
          })
        }else{
          this.$router.push({
            path:'/'
          })
        }
      });
    },
    getCookie(name) {
      //读取cookie
      var arr = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]*)(;|$)")
      );
      if (arr != null) return unescape(arr[2]);
      return null;
    },
    // 获取sign
    getSign() {
      var cookie = this.getCookie("_uc_t_");
      if (cookie != null) {
        var arr = cookie.split(";");
        return arr[2];
      }
      return null;
    },
    checkTab(type){
      if(type === 1){
        this.helpNum = 1
        this.$refs.myQuestion.getMyQuestion()
        zhugeTrack('Web_我的问答页-点击我的提问')
      }else{
        this.helpNum = 2
        this.$refs.myAnswer.getMyAnswer()
        zhugeTrack('Web_我的问答页-点击我的回答')
      }
    },
    getTotal(type, num){
      if(type === 'q'){
        this.questionTotal = num
      }else if(type === 'a'){
        this.answerTotal = num
      }else{
        this.questionTotal = ""
        this.answerTotal = ""
      }
    },
  }
}
</script>

<style lang="less" scoped>
.my-help{
  // 我的信息
  .my-info-box{
    padding-top: 20px;
    width: 100%;
    box-sizing: border-box;
    .my-info-cont{
      padding: 24px 30px;
      background: #fff;
      display: flex;
      .user-photo{
        width: 80px;
        height: 80px;
        margin-right: 24px;
        img{
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
      }
      .user-name-box{
        p{
          color: #1b3056;
        }
        .user-name{
          font-size: 24px;
          line-height: 33px;
          font-weight: bold;
        }
        .user-introduce{
          font-size: 16px;
          line-height: 22px;
          margin: 25px 0 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  // 内容
  .my-help-cont{
    margin-top: 20px;
    .container{
      display: flex;
      .help-nav{
        width: 200px;
        height: 600px;
        background-color: #ffffff;
        border-radius: 4px;
        padding-top: 15px;
        box-sizing: border-box;
        li{
          font-size: 15px;
          padding:0 20px;
          cursor: pointer;
          margin-bottom: 7px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span{
            display: inline-block;
            color: #1b3056;
            font-size: 15px;
          }
          .text{
            position: relative;
            padding-left: 30px;
            &::before{
              content:"";
              display: block;
              position: absolute;
              top:50%;
              left:0;
              transform: translateY(-50%);
            }
          }
          &:hover{
            background-color: #f1fbf8;
            .text{
              color: #25c48b;
            }
          }
        }
        li:nth-of-type(1){
          .text{
            &::before{
              width: 19px;
              height: 16px;
              background: url(../image/help/icon-myQuestion.png) no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        li:nth-of-type(2){
          .text{
            &::before{
              width: 18px;
              height: 19px;
              background: url(../image/help/icon-myAnswer.png) no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .active{
          background-color: #f1fbf8;
          .text{
            color: #25c48b;
          }
        }
      }
      .help-list-box{
        margin-left: 20px;
        flex: 1;
        background: #fff;
        border-radius: 4px;
        padding: 24px 30px 30px;
        .title{
          padding-left: 18px;
          position: relative;
          font-size: 20px;
          height: 20px;
          line-height: 20px;
          margin-bottom: 24px;
          &::before{
            content:"";
            display: block;
            position: absolute;
            top: 1px;
            left: 0;
            width: 5px;
            height: 18px;
            background-color: #25c48b;
          }
        }
      }
    }
  }


  // tab切换
  /deep/ .type-list{
    display: flex;
    li{
      padding: 6px 20px;
      line-height: 20px;
      border: solid 1px #dce0e4;
      font-size: 14px;
      color: #1b3056;
      border-left: 0;
      cursor: pointer;
      &:hover{
        color: #ffffff;
        border: solid 1px #25c48b;
        border-left: 0;
        background-color: #25c48b;
      }
    }
    li:first-child{
      border: solid 1px #dce0e4;
      border-radius: 4px 0 0 4px;
      &:hover{
        border: solid 1px #25c48b;
      }
    }
    li:last-child{
      border-radius: 0 4px 4px 0;
    }
    .active{
      color: #ffffff;
      border: solid 1px #25c48b;
      border-left: 0;
      background-color: #25c48b;
    }
    li:first-child.active{
      border: solid 1px #25c48b;
    }
    }

  // 缺省
  /deep/ .default-box{
    padding: 120px 0 170px;
    text-align: center;
    p{
      margin-top: 30px;
      font-size: 16px;
      color: #818b9c;
    }
  }
}

@media (min-width: 1200px) {
  .container {
    width: 1170px !important;
    max-width: 100%;
    padding:0;
  }
}
@media (max-width: 1199px) {
  .container {
    width: 100% !important;
    max-width: 100%;
  }
}
@media (max-width: 991px) {
  .container{
    width: 100% !important;
    max-width:100% !important;
    padding: 0 20px;
  }
}
</style>